import { ResourceScope } from '@app-types/blackroom-app';

import { ResourcePathItem } from './types';

export function getResourcePathItemUrl(
  item: ResourcePathItem,
  workspaceId: string,
  scope: ResourceScope,
) {
  if (item.id === 'root') {
    return `/workspace/${workspaceId}/resources/${scope}`;
  }

  return `/workspace/${workspaceId}/resources/${scope}/${encodeURIComponent(item.id ?? '')}`;
}
